"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyAttackDamages = void 0;
function applyAttackDamages(args) {
    const { attackerId, targetId, toApply, isCrit, attackType } = args;
    if (toApply.length === 0) {
        return {
            applied: []
        };
    }
    let { sequence } = args;
    sequence = sequence.pushSequence("parallel");
    const applied = Array.of();
    for (const damage of toApply) {
        const result = this.applyAttackDamage({
            attackType,
            attackerId,
            targetId,
            isCrit,
            toApply: damage,
            sequence
        });
        applied.push(result.damage);
    }
    return {
        applied
    };
}
exports.applyAttackDamages = applyAttackDamages;
